jQuery(document).ready(function ($) {
  $(".wgp__english-stories-section").each(function () {
    const $section = $(this);
    const loadedPostIds = new Set();
    let isLoading = false;

    const $container = $section.find(".wgp__english-stories-list");
    const $button = $section.find(".wgp__english-stories-load-more");

    const postsToShow = $section.data("posts-to-show") || 3;
    const isOverlayImage = $section.data("is-overlay-image") !== false;

    $section.find(".wgp__global-design--card-stories").each(function () {
      const postId = $(this).data("post-id");

      if (postId) {
        loadedPostIds.add(postId);
      }
    });

    if (!$button.length || !$container.length) {
      return;
    }

    $button.on("click", function () {
      if (isLoading) {
        return;
      }

      isLoading = true;
      $button.prop("disabled", true).addClass("is-loading");

      $.ajax({
        url: growDynamicBlocks.ajax_url,
        type: "POST",
        data: {
          action: "grow_load_more_english_stories",
          postsToShow: postsToShow,
          isOverlayImage: isOverlayImage,
          loadedPostIds: Array.from(loadedPostIds),
        },
        success: function (response) {
          if (response.success && response.data.html) {
            const $newPosts = $(response.data.html);

            $newPosts.each(function () {
              const postId = $(this).data("post-id");

              if (!loadedPostIds.has(postId)) {
                const $post = $(this).css("display", "none");

                $container.append($post);
                $post.fadeIn(300);
                loadedPostIds.add(postId);
              }
            });

            if (response.data.remaining <= 0 || $newPosts.length === 0) {
              $button.remove();
            }
          } else {
            $button.remove();
          }
        },
        error: function () {
          console.error("Error while loading English stories");
        },
        complete: function () {
          isLoading = false;
          $button.prop("disabled", false).removeClass("is-loading");
        },
      });
    });
  });
});